interface TrackingConfig {
  googleAnalytics?: string;
  googleTagManager?: string;
  googleAds?: string;
  facebookPixel?: string;
}

interface CookieConsent {
  analytics: boolean;
  marketing: boolean;
  timestamp: number;
}

export const loadTrackingScripts = (consent: CookieConsent, config: TrackingConfig) => {
  if (consent.analytics) {
    // Load Google Analytics
    if (config.googleAnalytics) {
      loadGoogleAnalytics(config.googleAnalytics);
    }
    
    // Load Google Tag Manager
    if (config.googleTagManager) {
      loadGoogleTagManager(config.googleTagManager);
    }
  }

  if (consent.marketing) {
    // Load Google Ads
    if (config.googleAds) {
      loadGoogleAds(config.googleAds);
    }
    
    // Load Facebook Pixel
    if (config.facebookPixel) {
      loadFacebookPixel(config.facebookPixel);
    }
  }
};

const loadGoogleAnalytics = (id: string) => {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', id);
};

const loadGoogleTagManager = (id: string) => {
  const script = document.createElement('script');
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${id}');
  `;
  document.head.appendChild(script);
};

const loadGoogleAds = (id: string) => {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', id);
};

const loadFacebookPixel = (id: string) => {
  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${id}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
};

// Type definitions for global objects
declare global {
  interface Window {
    dataLayer: any[];
    fbq?: (command: string, action: string, parameters?: any) => void;
    gtag: (command: string, action: string, parameters: any) => void;
  }
} 